import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import ListIcon from "@material-ui/icons/List";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";
import BarChartIcon from "@material-ui/icons/BarChart";
import "./SharesNavbarMenu.css";

import awraaq from '../assets/img/logo2.svg';
export default function SharesNavbarMenu() {
  return (
    <Navbar expand="lg" className="custom-navbar sticky-top">
      <Container>
        <Navbar.Brand as={Link} to="/shares-platform" className="navbar-brand-custom">
          <div className="brand-container">
            <img
              src={awraaq}
              alt="Logo"
              className="navbar-logo"
            />
            <div className="brand-text-container">
              <span className="brand-subtitle">BlockShares™</span>
            </div>
          </div>
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="custom-toggler"
        />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/shares-platform/plans" className="nav-link-custom">
              <ListIcon className="nav-icon" />
              Plans
            </Nav.Link>
            <Nav.Link as={Link} to="/shares-platform/fund" className="nav-link-custom">
              <AttachMoneyIcon className="nav-icon" />
              Fund
            </Nav.Link>
            <Nav.Link as={Link} to="/shares-platform/transaction" className="nav-link-custom">
              <CompareArrowsIcon className="nav-icon" />
              Transaction
            </Nav.Link>
            <Nav.Link as={Link} to="/shares-platform/report" className="nav-link-custom">
              <BarChartIcon className="nav-icon" />
              Report
            </Nav.Link>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
